import { Component, OnInit, Input } from "@angular/core";
import { MModuleListItem } from "../../models/module-list-item.model";
import { TranslateService } from "@ngx-translate/core";
import { MCurrentVersion } from "../../models/current-version.model";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SieniService } from "../../services/sieni.service";
import { Alert } from "../../models/alert.model";
import { Router } from "@angular/router";
import * as moment from "moment";
import { MModuleEvaluation } from "../../models/module-evaluation.model";
import { MEvaluation } from "../../models/evaluation.model";

@Component({
  selector: "module-item",
  templateUrl: "./module-item.component.html",
  styleUrls: ["./module-item.component.scss"],
})
export class ModuleItemComponent implements OnInit {
  constructor(
    private translate: TranslateService,
    private modalService: NgbModal,
    private _globalService: SieniService,
    private router: Router
  ) {}

  @Input() public module: MModuleListItem;
  @Input() public version: MCurrentVersion;
  @Input() public isEducational: boolean = null;
  public isCanceling: boolean = false;
  public isCreatingEvaluation: boolean = false;

  ngOnInit() {
    this.translate.setDefaultLang("es");
    this.translate.use("es");
    this.translate.use(this._globalService.user.language.code);
    if (this.version.currentEvaluation) {
      this.version.currentEvaluation.startDate = this.version.currentEvaluation.startDate.substr(
        0,
        this.version.currentEvaluation.startDate.indexOf(" ")
      );
    }
    console.log(this.version.currentEvaluation);
  }

  public openConfirmModal(content, content2) {
    if (this.version.activeEvaluation) {
      if (!this.isEducational) {
        this.modalService
          .open(content, {
            centered: true,
          })
          .result.then(
            (res) => {
              let day = this.version.currentEvaluation.startDate.substr(0, 2);
              let month = this.version.currentEvaluation.startDate.substr(3, 2);
              let year = this.version.currentEvaluation.startDate.substr(6, 4);
              const date = year + "-" + month + "-" + day;
              // Este el caso cuando se acepto cerrar y guardar la evaluacion

              this.isCanceling = true;
              // console.log(moment.utc().format('YYYY-MM-DD'))
              this._globalService
                .updateEvaluation(
                  this.version.currentEvaluation.id,
                  date,
                  moment.utc().format("YYYY-MM-DD"),
                  2,
                  this.version.currentEvaluation.moduleSubversionId
                )
                .subscribe(
                  (res) => {
                    this.isCanceling = false;
                    this.version.oldEvaluation = this.version.currentEvaluation;
                    this.setEvaluationFalse();
                    Alert.buildSuccessAlert(
                      this.translate.instant("evaluations.close.success")
                    );
                  },
                  (err) => {
                    this.isCanceling = false;
                    Alert.buildErrorAlert(
                      this.translate.instant("evaluations.close.error")
                    );
                  }
                );
            },
            (err) => {
              if (err && err !== 0) {
                // Si se presiona la segunda opcion, abre la segunda modal

                this.modalService
                  .open(content2, { centered: true })
                  .result.then(
                    (res) => {
                      //En este caso se elimina la evaluacion

                      this.isCanceling = true;
                      this._globalService
                        .deleteEvaluation(this.version.currentEvaluation.id)
                        .subscribe(
                          (res) => {
                            this.isCanceling = false;
                            this.setEvaluationFalse();
                            Alert.buildSuccessAlert(
                              this.translate.instant(
                                "evaluations.cancel.success"
                              )
                            );
                          },
                          (err) => {
                            this.isCanceling = false;
                            Alert.buildErrorAlert(
                              this.translate.instant("evaluations.cancel.error")
                            );
                          }
                        );
                    },
                    (err) => {}
                  );
              }
            }
          );
      } else {
        this.modalService.open(content2, { centered: true }).result.then(
          (res) => {
            //En este caso se elimina la evaluacion

            this.isCanceling = true;
            this._globalService
              .deleteEvaluation(this.version.currentEvaluation.id)
              .subscribe(
                (res) => {
                  this.isCanceling = false;
                  this.setEvaluationFalse();
                  Alert.buildSuccessAlert(
                    this.translate.instant("evaluations.cancel.success")
                  );
                },
                (err) => {
                  this.isCanceling = false;
                  Alert.buildErrorAlert(
                    this.translate.instant("evaluations.cancel.error")
                  );
                }
              );
          },
          (err) => {}
        );
      }
    }
  }

  public checkModuleDetails() {
    if (this.version.activeEvaluation) {
      this.router.navigate([
        "/sieni",
        "evaluations",
        this.module.id,
        "version",
        this.version.id,
      ]);
    } else {
      this.isCreatingEvaluation = true;
      this._globalService.startEvaluation(this.version.id).subscribe(
        ({ data }: any) => {
          // console.log(data)
          if (data.subversion) {
            const eva: MEvaluation = new MEvaluation(data);
            this._globalService
              .createEvaluation(
                moment.utc().format("YYYY-MM-DD"),
                eva.subversion.id,
                1
              )
              .subscribe(
                (res) => {
                  Alert.buildSuccessAlert(
                    this.translate.instant("evaluations.newEvaluation.start", {
                      module: this.module.name + ":" + this.version.version,
                    })
                  );
                  this.router.navigate([
                    "/sieni",
                    "evaluations",
                    this.module.id,
                    "version",
                    this.version.id,
                  ]);
                },
                (err) => {
                  this.isCreatingEvaluation = false;
                  Alert.buildErrorAlert(
                    this.translate.instant("evaluations.newEvaluation.error", {
                      module: this.module.name + ":" + this.version.version,
                    })
                  );
                }
              );
          } else {
            this.isCreatingEvaluation = false;
            Alert.buildErrorAlert(
              this.translate.instant("evaluations.newEvaluation.noChapters", {
                module: this.module.name + ":" + this.version.version,
              })
            );
          }
        },
        (err) => {
          this.isCreatingEvaluation = false;
          Alert.buildErrorAlert(
            this.translate.instant("evaluations.newEvaluation.error", {
              module: this.module.name + ":" + this.version.version,
            })
          );
        }
      );
    }
  }

  private setEvaluationFalse() {
    this.version.activeEvaluation = false;
    this.version.currentEvaluation = null;
  }
}
